import { PlayerChrome } from "@/components/pdp/PlayerChrome";
import { EYE_REPAIR_V32 } from "@/data/eyeRepairV32";
import { ArrowRight } from "lucide-react";

// HP3 — "Meet Dr. Rivers" reusing the PDP3.2 content + teal treatment, but as
// a full-bleed split: LEFT media bleeds to the left edge and fills the screen
// height (with the HP2-style video chrome kept over the image), RIGHT copy
// unchanged. Wrapped in `.pdp-scope v32` so eyebrow/CTA inherit the teal swap.
export const DrRiversV3 = () => {
  const { storyB } = EYE_REPAIR_V32;
  return (
    <section className="pdp-scope v32 w-full" data-testid="home-dr-rivers-v3">
      <div className="grid grid-cols-1 lg:grid-cols-2 items-stretch">
        {/* Left — full-bleed media, full screen height, video chrome kept */}
        <div className="relative min-h-[52vh] lg:min-h-[600px] lg:h-[78vh] overflow-hidden bg-white" data-testid="dermo-media">
          <img
            src={storyB.image}
            alt={storyB.imageAlt}
            className="absolute inset-0 w-full h-full object-cover img-zoom"
            draggable={false}
          />
          <PlayerChrome time="0:00 / 0:18" progress={0} />
        </div>

        {/* Right — copy unchanged */}
        <div className="flex flex-col justify-center px-8 sm:px-12 lg:px-16 py-16 lg:py-0 bg-riversol-paper">
          <div className="max-w-xl">
            <div className="pdp-eyebrow font-mono text-[11px] tracking-[0.24em] uppercase text-riversol-blue mb-6">
              {storyB.eyebrow}
            </div>
            <h2 className="text-2xl md:text-3xl lg:text-[2rem] leading-[1.2] tracking-tight font-serif italic font-normal text-neutral-900 mb-8">
              {storyB.titleLines.map((l, i) => (
                <span key={i} className="block font-sans">{l}</span>
              ))}
            </h2>
            <p className="text-[16px] lg:text-[17px] leading-[1.75] lg:leading-[1.8] text-neutral-600 mb-6">
              {storyB.p1}
            </p>
            <p className="text-[16px] lg:text-[17px] leading-[1.75] lg:leading-[1.8] text-neutral-600">
              {storyB.p2}
            </p>

            <a
              href="https://www.riversol.com/pages/about-us"
              data-testid="dermo-cta"
              className="mt-8 inline-flex items-center gap-2 bg-riversol-blue text-white px-8 py-3.5 text-[12px] tracking-[0.14em] uppercase font-medium hover:bg-riversol-blueLight transition-colors"
            >
              Meet Dr. Rivers
              <ArrowRight size={15} strokeWidth={1.8} />
            </a>

            <div className="mt-8 lg:mt-10 pt-6 lg:pt-8 border-t border-neutral-200">
              <div className="text-sm font-medium text-neutral-900">{storyB.personName}</div>
              <div className="text-xs text-neutral-500 font-mono tracking-wide">{storyB.personRole}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DrRiversV3;
